import React, { useState } from "react";
import { Badge, Box, Stack, Image, Avatar } from "@chakra-ui/react";
import { useRouter } from "next/router";
import { CloseIcon, ChevronDownIcon } from "@chakra-ui/icons";
import styles from "../../styles/components/homePage.module.css";
import UiButton from "../atoms/UiButton";

function WhyShouldHire() {
  const router = useRouter();
  const whyHireCard = [
    {
      heading: "Free to Use",
      desription: "Hassle free booking process: You never pay to use CoverClap",
      giftImage: "/new-ui/images/gift.svg",
    },
    {
      heading: "Huge Range of Local Experts",
      desription:
        "Get the best beauty professionals in Montreal with just a few clicks ",
      giftImage: "/new-ui/images/sezer.svg",
    },
    {
      heading: "Inclusive Beauty Experience",
      desription:
        "Everyone deserves access to quality beauty services, and our platform makes that possible",
      giftImage: "/new-ui/images/group.svg",
    },
  ];
  return (
    <Box className={styles.WhyHire_CONTAINER}>
      <Box className={styles.QA_Heading}>
        Why Hire Beauty Professionals on CoverClap?
      </Box>
      <Box className={styles.cardContainer}>
        {whyHireCard?.map((item) => {
          return (
            <Box className={styles.BottomCard}>
              <Box className={styles.imageContainer}>
                <img src={item.giftImage} alt="Badge" />
              </Box>
              <Box className={styles.cardHeading}>{item.heading}</Box>
              <Box className={styles.cardDescription}>{item.desription}</Box>
            </Box>
          );
        })}
      </Box>
      <img
        className={styles.blog__top__bottomBgSM}
        src="/new-ui/images/WhyHire.png"
      />
      <Box px="20px">
        <Box
          margin="auto"
          mb={["88px", "148px"]}
          mt={["30px", "55px"]}
          width={["100%", "172px", "172px"]}
          height="54px"
          borderRadius={"full"}
        >
          <UiButton
            onClick={() => {}}
            bgColor={"#64E0F5"}
            color={"#000000"}
            hFull
            label={"Get Started"}
          />
        </Box>
      </Box>
    </Box>
  );
}

export default WhyShouldHire;
